import React, { useState, useEffect } from 'react';
import LandlordLogin from '../pages/LandlordLogin';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = () => {
    try {
      const token = localStorage.getItem('landlord_token');
      const user = localStorage.getItem('landlord_user');
      
      console.log('🔍 Checking authentication:', { hasToken: !!token, hasUser: !!user });
      
      if (token && user) {
        // Verify token format (basic check)
        if (token.split('.').length === 3) {
          setIsAuthenticated(true);
          console.log('✅ User is authenticated');
        } else {
          console.log('❌ Invalid token format');
          localStorage.removeItem('landlord_token');
          localStorage.removeItem('landlord_user');
          setIsAuthenticated(false);
        }
      } else {
        console.log('❌ No valid authentication found');
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Authentication check error:', error);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSuccess = (userData) => {
    console.log('🎉 Login success callback received:', userData);
    setIsAuthenticated(true);
    setLoading(false);
  };

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return <LandlordLogin onLoginSuccess={handleLoginSuccess} />;
  }

  // If authenticated, render protected content
  return children;
};

export default ProtectedRoute;